import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { getUrl } from './get-url.js'

Vue.use(Vuex);
axios.defaults.baseURL = '';

export const store = new Vuex.Store({
    state: {
        user: null,
        token: localStorage.getItem('access_token') || null,
        filter: 'all',
    },
    getters: {
        loggedIn: (state) => {
            return state.token;
        },

        getUser: (state) => {
            return state.user !== null;
        }
    },
    mutations: {
        retrieveToken(state, token) {
            state.token = token;
        },
        destroyToken(state) {
            state.token = null;
        },
        setUser(state, user) {
            state.user = user;
        }
    },
    actions: {
        register(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/token', {
                    email: data.email,
                    password: data.password,
                }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post(getUrl('/token'), {
                    email: credentials.email,
                    passwordHash: credentials.passwordHash,
                }).then(response => {
                    const token = response.data;
                    localStorage.setItem('access_token', token);
                    context.commit('retrieveToken', token);
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        setUser(context, data) {

        }
    }
});


// WEBPACK FOOTER //
// ./src/services/store.js